// PRD §4.1 — 8–64 chars, must include letter + digit + special.
// Single source of truth for Login, My Profile password-change adapter,
// and the password-change form's client-side check.
export const PASSWORD_POLICY_RE =
  /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>/?]).{8,64}$/;
